import {getOrderRow} from '../utils/utils'

const baseFilter = {
    status: null,
    'guest-name': '',
    'shift-number': '',
    operator_id: null,
    num: '',
    price_min: '',
    price_max: '',
    dep_id: null,
    'order-date': null,
}

export default {
    ADD_TO_ORDERS(state, lists) {
        const searches = []
        if (lists != null) {
            lists.forEach(e => {
                searches.push(getOrderRow(e))
            })
            state.orders = searches
        } else {
            state.orders = []
        }
    },
    SET_COUNT(state, count) {
        state.totalOrders = count
    },

    SET_PARAMS(state, params) {
        state.paramsSearch = params
    },
    CLEAR_STORE(state) {
        state.orders = []
        state.totalOrders = 0
        state.openOrders = null
        state.paramsSearch = {
            status: null,
            'guest-name': '',
            'shift-number': '',
            operator: '',
            num: '',
            price_min: '',
            price_max: '',
            dep_id: null,
            'order-date': null,
        }
    },
    SET_OPEN_ORDERS(state, openOrders) {
        state.openOrders = openOrders
    },

    SET_PARAMS_FOR_CALLING(state, params) {
        state.paramsSearchForCalling = params
    },
    SET_PARAM_FOR_CALLING(state, {attribute, val}) {
        state.paramsSearchForCalling[attribute] = val
    },
    CLEAR_PARAMS_FOR_CALLING(state) {
        state.paramsSearchForCalling = JSON.parse(JSON.stringify(baseFilter))
    },
    CLEAR_OPEN_ORDERS(state) {
        state.openOrders = null
        state.orders = []
        state.totalOrders = 0
    },
}
